import React from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  useMediaQuery,
  useTheme,
  IconButton
} from "@mui/material";
import {
  Home as HomeIcon,
  Group as GroupIcon,
  Add as AddIcon,
  ShoppingBag as ShoppingBagIcon,
  Business as BusinessIcon,
  Brightness4,
  Brightness7
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useTheme as useCustomTheme } from "../../ThemeContext";

function MobileBottomNavbar() {
  const theme = useTheme();
  const { darkMode, toggleTheme } = useCustomTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();

  // Only render on mobile
  if (!isMobile) {
    return null;
  }

  const getCurrentValue = () => {
    const path = location.pathname;
    if (path === '/') return 0;
    if (path === '/clubs') return 1;
    if (path === '/create-club') return 2;
    if (path === '/merch') return 3;
    if (path === '/sponsor') return 4;
    return 0;
  };

  const handleNavigation = (event, newValue) => {
    const routes = ['/', '/clubs', '/create-club', '/merch', '/sponsor'];
    if (routes[newValue]) {
      window.location.href = routes[newValue];
    }
  };

  return (
    <BottomNavigation
      value={getCurrentValue()}
      onChange={handleNavigation}
      showLabels
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.appBar,
        '& .MuiBottomNavigationAction-root': {
          minWidth: 'auto',
          padding: '6px 0',
        },
        '& .MuiBottomNavigationAction-label': {
          fontSize: '0.75rem',
          fontWeight: 500,
        }
      }}
    >
      <BottomNavigationAction
        label="Home"
        icon={<HomeIcon />}
        component={RouterLink}
        to="/"
      />
      <BottomNavigationAction
        label="Clubs"
        icon={<GroupIcon />}
        component={RouterLink}
        to="/clubs"
      />
      <BottomNavigationAction
        label="Create"
        icon={<AddIcon />}
        component={RouterLink}
        to="/create-club"
      />
      <BottomNavigationAction
        label="Merch"
        icon={<ShoppingBagIcon />}
        component={RouterLink}
        to="/merch"
      />
      <BottomNavigationAction
        label="Sponsor"
        icon={<BusinessIcon />}
        component={RouterLink}
        to="/sponsor"
      />
    </BottomNavigation>
  );
}

export default MobileBottomNavbar;
